import { render, staticRenderFns } from "./ReviewSteps.vue?vue&type=template&id=5361fa74&scoped=true&"
import script from "./ReviewSteps.vue?vue&type=script&lang=js&"
export * from "./ReviewSteps.vue?vue&type=script&lang=js&"
import style0 from "./ReviewSteps.vue?vue&type=style&index=0&id=5361fa74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5361fa74",
  null
  
)

export default component.exports